/* ============================================================
   AYDO® — store behaviour: search dropdown, cart drawer,
   quick add, async recommendations, and product rails.

   Everything is `data-ay-*` namespaced so it cannot collide with
   Fabric's own scripts, which are still running on this page.
   ============================================================ */
(function () {
  "use strict";

  var RM = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var CLOSE_MS = RM ? 0 : 300;

  /* Oversatte strenge kommer fra snippets/aydo-js-strings.liquid.
     Mangler bro'en, falder vi tilbage til den engelske streng. */
  function T(k, fallback) {
    var d = window.AYDO_T;
    return (d && typeof d[k] === "string" && d[k]) ? d[k] : fallback;
  }

  function on(el, ev, fn, opts) { if (el) el.addEventListener(ev, fn, opts); }
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }
  function esc(s) {
    return String(s == null ? "" : s).replace(/[&<>"']/g, function (c) {
      return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c];
    });
  }

  /* ---------- focus trap shared by the drawer and the dropdown ---- */
  function trap(container, e) {
    if (e.key !== "Tab") return;
    var f = all("a[href], button:not([disabled]), input, select, textarea", container)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  /* ============================================================
     Search dropdown
     Predictive search, so the shopper keeps the page they were on.
     The <form> still posts to /search if scripting never arrives.
     ============================================================ */
  (function () {
    var panel = document.querySelector("[data-ay-srch]");
    if (!panel) return;

    var input = panel.querySelector("[data-ay-srch-input]");
    var live = panel.querySelector("[data-ay-srch-live]");
    var hint = panel.getAttribute("data-ay-srch-hint") || T("type_to_search", "Type to search");
    var opener = null, timer = null, seq = 0;

    function say(msg) {
      live.innerHTML = '<div data-ay-srch-out><p class="ay-srch__note">' + esc(msg) + "</p></div>";
    }

    function open(from) {
      opener = from || document.activeElement;
      panel.hidden = false;
      /* reflow, then set synchronously — rAF is throttled in background
         tabs and would leave the panel stuck at opacity 0 */
      void panel.offsetWidth;
      panel.dataset.open = "true";
      if (input) input.focus({ preventScroll: true });
    }
    function close(refocus) {
      panel.dataset.open = "false";
      setTimeout(function () { panel.hidden = true; }, CLOSE_MS);
      if (refocus && opener && opener.focus) opener.focus({ preventScroll: true });
    }
    panel._ayOpen = open;

    all("[data-ay-srch-close]").forEach(function (b) { on(b, "click", function () { close(true); }); });
    on(document, "keydown", function (e) {
      if (panel.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(true); return; }
      trap(panel, e);
    });
    on(document, "click", function (e) {
      if (panel.hidden || panel.dataset.open !== "true") return;
      if (panel.contains(e.target) || (e.target.closest && e.target.closest("[data-ay-srch-open]"))) return;
      close(false);
    });
    all("[data-ay-srch-open]").forEach(function (b) {
      on(b, "click", function (e) { e.preventDefault(); open(b); });
    });

    /* Results come back as rendered Liquid from sections/aydo-predictive,
       so prices are formatted by `| money` rather than by this file. */
    function search(q) {
      var mine = ++seq;
      var url = "/search/suggest?q=" + encodeURIComponent(q) +
        "&resources[type]=product&resources[limit]=12&section_id=aydo-predictive";
      fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          if (mine !== seq) return; /* a newer keystroke already won */
          var next = new DOMParser().parseFromString(html, "text/html")
            .querySelector("[data-ay-srch-out]");
          if (next) live.innerHTML = next.outerHTML;
        })
        .catch(function () {
          if (mine !== seq) return;
          say(T("search_down", "Search is unavailable right now"));
        });
    }

    on(input, "input", function () {
      var q = input.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { seq++; say(hint); return; }
      say(T("searching", "Searching…"));
      timer = setTimeout(function () { search(q); }, 220);
    });
  })();

  /* ============================================================
     Cart drawer
     Re-rendered server-side through the Section Rendering API, so
     every price, discount and free-shipping figure stays Shopify's
     own — none of that arithmetic is repeated here.
     ============================================================ */
  var Cart = (function () {
    var drawer = document.querySelector("[data-ay-cart]");
    if (!drawer) return { add: function () {}, open: function () {} };

    var inner = drawer.querySelector("[data-ay-cart-inner]");
    var opener = null;

    function syncCount() {
      var n = inner.getAttribute("data-ay-cart-count");
      if (n === null) return;
      all("[data-ay-cart-count-target]").forEach(function (el) {
        el.textContent = n;
        el.setAttribute("data-empty", n === "0" ? "true" : "false");
      });
    }
    syncCount();

    /* The product page carries its own free-shipping counter, and it is
       NOT inside the drawer, so a section render does not touch it.
       Rather than re-implement the maths and the money format in JS,
       copy across what the drawer just rendered — Shopify stays the only
       thing doing arithmetic, exactly as the comment at the top says.
       With an empty bag the drawer omits the block entirely, so the bar
       falls back to its own "free shipping over X" wording. */
    function syncShip() {
      var bar = document.querySelector("[data-ay-ship]");
      if (!bar) return;
      var txt = bar.querySelector(".ay-ship__txt");
      var fill = bar.querySelector(".ay-ship__fill");
      var srcTxt = inner.querySelector(".ay-cart__shiptxt");
      var srcFill = inner.querySelector(".ay-cart__fill");
      if (txt) {
        if (srcTxt) txt.innerHTML = srcTxt.innerHTML;
        else txt.textContent = bar.getAttribute("data-ay-ship-empty") || txt.textContent;
      }
      if (fill) fill.style.width = srcFill ? srcFill.style.width || "0%" : "0%";
    }
    syncShip();

    function open(from) {
      opener = from || document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.dataset.open = "true";
      document.body.style.overflow = "hidden";
      var f = drawer.querySelector(".ay-cart__x");
      if (f) f.focus({ preventScroll: true });
    }
    function close(refocus) {
      drawer.dataset.open = "false";
      document.body.style.overflow = "";
      setTimeout(function () { drawer.hidden = true; }, CLOSE_MS);
      if (refocus && opener && opener.focus) opener.focus({ preventScroll: true });
    }

    /* Pull a fresh render of just this section and swap it in. */
    function refresh() {
      var url = drawer.getAttribute("data-ay-cart-url");
      if (!url) return Promise.resolve();
      return fetch(url)
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var next = doc.querySelector("[data-ay-cart-inner]");
          if (next) { inner.innerHTML = next.innerHTML; inner.setAttribute("data-ay-cart-count", next.getAttribute("data-ay-cart-count") || "0"); }
          syncCount();
          syncShip();
        })
        .catch(function () {});
    }

    function busy(state) { drawer.dataset.busy = String(state); }

    function change(line, qty) {
      busy(true);
      fetch("/cart/change.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ line: line, quantity: qty })
      })
        .then(function () { return refresh(); })
        .then(function () { busy(false); })
        .catch(function () { busy(false); });
    }

    function add(id, btn) {
      if (btn) { btn.dataset.busy = "true"; btn.disabled = true; }
      return fetch("/cart/add.js", {
        method: "POST",
        headers: { "Content-Type": "application/json", Accept: "application/json" },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      })
        .then(function (r) { if (!r.ok) throw new Error("add failed"); return r.json(); })
        .then(function () { return refresh(); })
        .then(function () {
          if (btn) { btn.dataset.busy = "false"; btn.disabled = false; }
          open(btn);
        })
        .catch(function () {
          if (btn) { btn.dataset.busy = "false"; btn.disabled = false; }
          /* the variant went out of stock between render and click —
             the product page is the honest place to land */
          window.location.href = "/cart";
        });
    }

    on(drawer.querySelector(".ay-cart__scrim"), "click", function () { close(true); });
    on(document, "keydown", function (e) {
      if (drawer.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(true); return; }
      trap(drawer, e);
    });
    all("[data-ay-cart-open]").forEach(function (b) {
      on(b, "click", function (e) { e.preventDefault(); open(b); });
    });

    /* Delegated: the panel's markup is replaced wholesale on every
       refresh, so handlers bound to its children would not survive. */
    on(drawer, "click", function (e) {
      if (!e.target.closest) return;
      var line = e.target.closest("[data-ay-line]");
      if (line) {
        e.preventDefault();
        change(Number(line.getAttribute("data-ay-line")), Number(line.getAttribute("data-ay-qty")));
        return;
      }
      var c = e.target.closest("[data-ay-cart-close]");
      if (!c) return;
      /* the empty-state button is a real link — let it navigate */
      if (c.tagName !== "A") { e.preventDefault(); close(true); } else { close(false); }
    });

    return { add: add, open: open, refresh: refresh };
  })();

  /* ---------- region drawer (country + language) ----------- */
  /* Same gesture as the cart: scrim, panel off the right edge, Escape,
     focus trap, body-scroll lock. The one thing it adds is filtering the
     language list to the country that is checked — Denmark offers Danish
     and English, Poland offers English only, and a dead option in a list
     is worse than no option at all.

     The country rows carry data-langs because Liquid can only describe
     the market the shopper is in right now; it cannot answer "what would
     Norway offer?". Shopify still has the final say — it rejects a locale
     it does not publish for the chosen market whatever this list shows. */
  (function () {
    var drawer = document.querySelector("[data-ay-rgn]");
    if (!drawer) return;
    var opener = null;
    var langs = drawer.querySelector("[data-ay-rgn-langs]");

    function syncLangs() {
      if (!langs) return;
      var country = drawer.querySelector("[data-ay-rgn-country]:checked");
      if (!country) return;
      var allowed = (country.getAttribute("data-langs") || "en").split(/\s+/);
      var visible = [];
      all("li[data-lang]", langs).forEach(function (li) {
        var ok = allowed.indexOf(li.getAttribute("data-lang")) !== -1;
        li.hidden = !ok;
        if (ok) visible.push(li);
      });
      /* If the checked language just disappeared, the form would post a
         locale the new market does not publish, so fall back to the first
         one still standing.

         Note what this deliberately does NOT do: it does not switch you to
         the local language when you pick a country. English is in every
         country's list, so an English reader who selects France stays in
         English and simply gains French as an option. Changing the country
         is a shipping decision; silently changing the language underneath
         someone who chose it is not part of that decision. */
      var checked = langs.querySelector("input:checked");
      if (!checked || checked.closest("li").hidden) {
        var first = visible[0] && visible[0].querySelector("input");
        if (first) first.checked = true;
      }
      /* A single language is not a choice — hide the whole fieldset
         rather than show a radio group of one. */
      langs.hidden = visible.length < 2;
    }

    function open(from) {
      opener = from || document.activeElement;
      drawer.hidden = false;
      void drawer.offsetWidth;
      drawer.dataset.open = "true";
      document.body.style.overflow = "hidden";
      all("[data-ay-rgn-open]").forEach(function (b) { b.setAttribute("aria-expanded", "true"); });
      var f = drawer.querySelector(".ay-rgn__x");
      if (f) f.focus({ preventScroll: true });
    }
    function close(refocus) {
      drawer.dataset.open = "false";
      document.body.style.overflow = "";
      all("[data-ay-rgn-open]").forEach(function (b) { b.setAttribute("aria-expanded", "false"); });
      setTimeout(function () { drawer.hidden = true; }, CLOSE_MS);
      if (refocus && opener && opener.focus) opener.focus({ preventScroll: true });
    }

    all("[data-ay-rgn-open]").forEach(function (b) {
      on(b, "click", function (e) { e.preventDefault(); open(b); });
    });
    on(drawer, "click", function (e) {
      if (!e.target.closest) return;
      if (e.target.closest("[data-ay-rgn-close]")) { e.preventDefault(); close(true); }
    });
    on(drawer, "change", function (e) {
      if (e.target.name === "country_code") syncLangs();
    });
    on(document, "keydown", function (e) {
      if (drawer.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(true); return; }
      trap(drawer, e);
    });

    syncLangs();
  })();

  /* ---------- quick add from a product card ---------------- */
  on(document, "click", function (e) {
    var b = e.target.closest ? e.target.closest("[data-ay-quickadd]") : null;
    if (!b || b.disabled) return;
    e.preventDefault();
    e.stopPropagation();
    Cart.add(b.getAttribute("data-ay-quickadd"), b);
  });

  /* ---------- PDP add to bag, into the drawer -------------- */
  (function () {
    var form = document.querySelector("[data-ay-pdp-form]");
    if (!form || !form.hasAttribute("data-ay-ajax")) return;
    var atc = form.querySelector("[data-ay-atc]");
    on(form, "submit", function (e) {
      var id = form.querySelector("[data-ay-variant-id]");
      if (!id || !id.value) return; /* aydo-brand.js shows the "pick a size" error */
      e.preventDefault();
      e.stopImmediatePropagation();
      Cart.add(id.value, atc);
    }, true);
  })();

  /* ---------- async product recommendations ----------------
     `recommendations.products` is only populated on a request to
     /recommendations/products, so the section fetches its own
     markup and swaps itself in. Empty result: it stays hidden. */
  all("[data-ay-recs]").forEach(function (el) {
    var url = el.getAttribute("data-ay-recs-url");
    if (!url) return;
    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, "text/html");
        var next = doc.querySelector("[data-ay-recs-inner]");
        if (!next || !next.innerHTML.trim()) return;
        el.innerHTML = next.outerHTML;
        el.hidden = false;
        /* the new cards were not in the DOM when the observer ran */
        all("[data-ay-reveal]", el).forEach(function (c) { c.dataset.ayIn = "true"; });
        /* …nor was the rail, which is why initRails takes a root */
        initRails(el);
      })
      .catch(function () {});
  });

  /* ---------- product rails (carousels) ---------------------
     An enhancement over a plain scroll container, not a replacement for
     one. The markup ships with the arrows `hidden`; they are revealed
     only once we can see that the track really does overflow, so a rail
     holding four cards on a screen that fits four does not grow two
     controls that do nothing. With scripting off they never appear and
     the rail is still swipeable and keyboard-scrollable.

     A click moves the track by its own clientWidth — one screenful of
     whatever CSS decided the card width should be. Nothing here knows or
     cares how wide a card is, and scroll-snap lands it on a card edge. */
  function initRails(root) {
    all("[data-ay-rail]", root || document).forEach(function (rail) {
      var track = rail.querySelector("[data-ay-rail-track]");
      if (!track || rail.dataset.ayRail === "on") return;
      rail.dataset.ayRail = "on";

      var nav  = rail.querySelector("[data-ay-rail-nav]");
      var prev = rail.querySelector("[data-ay-rail-prev]");
      var next = rail.querySelector("[data-ay-rail-next]");

      /* 4px rather than 0 everywhere below: a track whose cards add up to
         exactly the full width still leaves a sub-pixel fraction behind,
         and a 0.5px overflow is not something to grow arrows for. */
      function sync() {
        var over = track.scrollWidth - track.clientWidth;
        if (nav) nav.hidden = over <= 4;
        if (prev) prev.disabled = track.scrollLeft <= 4;
        if (next) next.disabled = track.scrollLeft >= over - 4;
      }

      function page(dir) {
        track.scrollBy({ left: dir * track.clientWidth, behavior: RM ? "auto" : "smooth" });
      }

      on(prev, "click", function () { page(-1); });
      on(next, "click", function () { page(1); });
      on(track, "scroll", sync, { passive: true });

      /* The card width is a percentage of the track, so every breakpoint
         and every window drag changes whether there is anything to scroll
         to. Watching the track catches both without a resize listener
         firing on scrollbar-only changes. */
      if ("ResizeObserver" in window) new ResizeObserver(sync).observe(track);
      else on(window, "resize", sync);

      sync();
    });
  }
  initRails();

  /* ============================================================
     Product-image lightbox
     The gallery crops every shot to 2:3 so the page stays tidy;
     this is where the crop is handed back. One overlay is built
     on first open and reused, because a PDP has up to a dozen
     shots and building twelve overlays up front is twelve times
     the DOM for something most visitors never open.
     ============================================================ */
  (function () {
    var shots = all("[data-ay-zoom]");
    if (!shots.length) return;

    var items = shots.map(function (s) {
      return { src: s.getAttribute("data-ay-zoom"), alt: s.getAttribute("data-ay-zoom-alt") || "" };
    });

    var lb = null, img = null, frame = null, count = null, prev = null, next = null;
    var idx = 0, opener = null;

    function build() {
      lb = document.createElement("div");
      lb.className = "ay ay-lb";
      lb.setAttribute("data-open", "false");
      lb.hidden = true;
      lb.innerHTML =
        '<div class="ay-lb__scrim" data-ay-lb-close></div>' +
        '<div class="ay-lb__stage" role="dialog" aria-modal="true" aria-label="' + esc(T("product_images", "Product images")) + '">' +
          '<div class="ay-lb__frame"><img alt=""></div>' +
        '</div>' +
        '<button class="ay-lb__btn ay-lb__x" type="button" data-ay-lb-close aria-label="' + esc(T("close", "Close")) + '">' +
          '<svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="1.6"/></svg></button>' +
        '<button class="ay-lb__btn ay-lb__prev" type="button" aria-label="' + esc(T("prev_image", "Previous image")) + '">' +
          '<svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M12 1L4 9l8 8" stroke="currentColor" stroke-width="1.6"/></svg></button>' +
        '<button class="ay-lb__btn ay-lb__next" type="button" aria-label="' + esc(T("next_image", "Next image")) + '">' +
          '<svg width="16" height="16" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M6 1l8 8-8 8" stroke="currentColor" stroke-width="1.6"/></svg></button>' +
        '<p class="ay-lb__count"></p>';
      document.body.appendChild(lb);

      frame = lb.querySelector(".ay-lb__frame");
      img = lb.querySelector(".ay-lb__frame img");
      count = lb.querySelector(".ay-lb__count");
      prev = lb.querySelector(".ay-lb__prev");
      next = lb.querySelector(".ay-lb__next");

      /* one image, so the arrows would be two dead controls */
      if (items.length < 2) { prev.hidden = true; next.hidden = true; count.hidden = true; }

      on(prev, "click", function () { show(idx - 1); });
      on(next, "click", function () { show(idx + 1); });
      all("[data-ay-lb-close]", lb).forEach(function (b) { on(b, "click", close); });

      /* click to magnify, click again to come back out */
      on(frame, "click", function (e) {
        var zoomed = frame.dataset.zoom === "true";
        frame.dataset.zoom = zoomed ? "false" : "true";
        if (!zoomed) track(e);
      });
      on(frame, "pointermove", function (e) {
        if (frame.dataset.zoom === "true") track(e);
      });
      on(frame, "pointerleave", function () {
        frame.style.removeProperty("--ay-lb-x");
        frame.style.removeProperty("--ay-lb-y");
      });
    }

    /* the pointer position becomes the transform-origin, which is what
       makes a scaled image pan instead of just growing from its middle */
    function track(e) {
      var r = frame.getBoundingClientRect();
      if (!r.width || !r.height) return;
      var x = ((e.clientX - r.left) / r.width) * 100;
      var y = ((e.clientY - r.top) / r.height) * 100;
      frame.style.setProperty("--ay-lb-x", Math.max(0, Math.min(100, x)) + "%");
      frame.style.setProperty("--ay-lb-y", Math.max(0, Math.min(100, y)) + "%");
    }

    function show(i) {
      idx = (i + items.length) % items.length;
      frame.dataset.zoom = "false";
      img.src = items[idx].src;
      img.alt = items[idx].alt;
      if (count) count.textContent = (idx + 1) + " / " + items.length;
    }

    function open(i) {
      if (!lb) build();
      opener = document.activeElement;
      show(i);
      lb.hidden = false;
      /* reflow, then set synchronously — rAF is throttled in background
         tabs and would leave the overlay stuck at opacity 0 */
      void lb.offsetWidth;
      lb.dataset.open = "true";
      document.body.style.overflow = "hidden";
      lb.querySelector(".ay-lb__x").focus({ preventScroll: true });
    }

    function close() {
      if (!lb) return;
      lb.dataset.open = "false";
      document.body.style.overflow = "";
      setTimeout(function () { lb.hidden = true; }, CLOSE_MS);
      if (opener && opener.focus) opener.focus({ preventScroll: true });
    }

    shots.forEach(function (s, i) {
      on(s, "click", function (e) { e.preventDefault(); open(i); });
    });

    on(document, "keydown", function (e) {
      if (!lb || lb.hidden) return;
      if (e.key === "Escape") { e.preventDefault(); close(); }
      else if (e.key === "ArrowLeft" && items.length > 1) { e.preventDefault(); show(idx - 1); }
      else if (e.key === "ArrowRight" && items.length > 1) { e.preventDefault(); show(idx + 1); }
      else trap(lb, e);
    });
  })();

  /* ============================================================
     Collection sort and pagination, in place
     Both keep real hrefs against Shopify, so they are shareable and
     correct without scripting. This just intercepts the click and
     fetches that same URL through the Section Rendering API, so the
     page never blinks. Any failure falls through to an ordinary
     navigation rather than stranding the shopper.

     The facets are NOT here — they are client-side, in the filter
     panel below, for the reasons set out in aydo-collection.liquid.
     ============================================================ */
  (function () {
    var root = document.querySelector("[data-ay-coll]");
    if (!root || !window.history.pushState || !window.DOMParser) return;
    var sid = root.getAttribute("data-ay-section-id");
    if (!sid) return;
    var busy = false;

    /* The sort <select> carries an inline onchange="this.form.submit()" so it
       works with scripting off. `form.submit()` fires no submit event, so it
       would slip straight past the handler below — strip the attribute now
       that we are here to take over, and again after every swap, since the
       markup is replaced wholesale. */
    function armSort() {
      all(".ay-sort select", root).forEach(function (s) { s.removeAttribute("onchange"); });
    }
    armSort();

    function load(url, push) {
      if (busy) return;
      busy = true;
      var results = root.querySelector("[data-ay-results]");
      var bar = root.querySelector(".ay-filters");
      if (results) results.dataset.busy = "true";
      if (bar) bar.dataset.busy = "true";

      var u;
      try { u = new URL(url, window.location.origin); }
      catch (err) { window.location.assign(url); return; }
      var fetchUrl = new URL(u.toString());
      fetchUrl.searchParams.set("section_id", sid);

      fetch(fetchUrl.toString())
        .then(function (r) { return r.text(); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, "text/html");
          var nextRoot = doc.querySelector("[data-ay-coll]");
          if (!nextRoot) throw new Error("no section");
          root.innerHTML = nextRoot.innerHTML;
          busy = false;
          armSort();
          /* the panel's markup went with the swap — rebuild it against the
             new grid, and re-apply whatever was already ticked */
          if (window.AYFilters) window.AYFilters.rebuild();
          if (push) window.history.pushState({ ayColl: true }, "", u.pathname + u.search);
          /* the new cards were not in the DOM when the reveal observer ran */
          all("[data-ay-reveal]", root).forEach(function (c) { c.dataset.ayIn = "true"; });
          var nowBar = root.querySelector(".ay-filters");
          if (nowBar && nowBar.getBoundingClientRect().top < 0) {
            nowBar.scrollIntoView({ block: "start", behavior: RM ? "auto" : "smooth" });
          }
        })
        .catch(function () { window.location.assign(url); });
    }

    on(root, "click", function (e) {
      var a = e.target.closest(".ay-pag__step, [data-ay-coll-link]");
      if (!a || !a.getAttribute("href")) return;
      /* leave modified clicks alone — they mean "open somewhere else" */
      if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
      e.preventDefault();
      load(a.href, true);
    });

    on(root, "change", function (e) {
      var sel = e.target.closest(".ay-sort select");
      if (!sel) return;
      var form = sel.form;
      if (!form) return;
      var u = new URL(form.getAttribute("action") || window.location.pathname, window.location.origin);
      u.searchParams.set("sort_by", sel.value);
      /* sort is a real navigation, so anything ticked has to travel with
         it or re-sorting would silently throw the filters away */
      if (window.AYFilters) window.AYFilters.writeParams(u.searchParams);
      load(u.toString(), true);
    });

    /* the sort <select> submits its form natively without JS; with JS the
       change handler above has already taken over, so stop the double trip */
    on(root, "submit", function (e) {
      if (e.target.closest(".ay-sort")) e.preventDefault();
    });

    /* No `e.state` guard. Going back from a filtered URL lands on the entry
       the page originally LOADED with, whose state is null — gating on the
       state left the address bar saying /aw26 while the grid still showed
       the six Rib pairs. Popstate only fires for same-document entries, so
       while this section is on the page every one of them is ours. */
    on(window, "popstate", function () { load(window.location.href, false); });
  })();
  /* ============================================================
     Filter panel
     Every card already carries its facets as data attributes, so
     filtering is a walk over the grid rather than a request — which
     is what lets several facets be on at once and answer instantly.
     Tag routing could not: it ANDs, and caps at three tags.

     Two things it has to get right. Counts are computed against the
     OTHER facets, not against the current result, so ticking "Blue"
     does not zero every length beside it. And a collection longer
     than one page has its remaining pages pulled in before the first
     filter runs, so the answer is the whole collection rather than
     whatever happened to be on page one.
     ============================================================ */
  (function () {
    var GROUPS = ["c", "l", "col", "stock"];
    var root, bar, panelEl, grid, state = {}, cards = [], loadedAll = false, opener = null, bound = false;

    function q(sel, ctx) { return (ctx || document).querySelector(sel); }

    function readParams(sp) {
      var next = {};
      GROUPS.forEach(function (g) {
        var raw = sp.get(g);
        next[g] = raw ? raw.split(",").filter(Boolean) : [];
      });
      return next;
    }
    function writeParams(sp) {
      GROUPS.forEach(function (g) {
        if (state[g] && state[g].length) sp.set(g, state[g].join(","));
        else sp.delete(g);
      });
      return sp;
    }
    function active() {
      return GROUPS.reduce(function (n, g) { return n + (state[g] ? state[g].length : 0); }, 0);
    }

    /* A card matches when it satisfies EVERY group that has something
       ticked, and any ONE value within that group — AND across, OR
       within, which is what people mean by "blue or green, mid calf". */
    function matches(card, skip) {
      for (var i = 0; i < GROUPS.length; i++) {
        var g = GROUPS[i];
        if (g === skip) continue;
        var want = state[g];
        if (!want || !want.length) continue;
        var has = (card.getAttribute("data-ay-f-" + g) || "").split(" ");
        var hit = false;
        for (var j = 0; j < want.length; j++) { if (has.indexOf(want[j]) > -1) { hit = true; break; } }
        if (!hit) return false;
      }
      return true;
    }

    function collect() {
      cards = root ? Array.prototype.slice.call(root.querySelectorAll("[data-ay-f]")) : [];
    }

    function paint() {
      var shown = 0;
      cards.forEach(function (card) {
        var ok = matches(card, null);
        card.hidden = !ok;
        if (ok) shown++;
      });

      /* per-option counts, each blind to its own group */
      GROUPS.forEach(function (g) {
        var group = q('[data-ay-fgroup="' + g + '"]', panelEl);
        if (!group) return;
        var pool = cards.filter(function (c) { return matches(c, g); });
        var live = 0;
        all("[data-ay-fopt]", group).forEach(function (opt) {
          var val = opt.getAttribute("data-ay-fopt");
          var box = q("input", opt);
          var n = 0;
          for (var i = 0; i < pool.length; i++) {
            if ((pool[i].getAttribute("data-ay-f-" + g) || "").split(" ").indexOf(val) > -1) n++;
          }
          /* an option nothing in this collection carries is not a filter,
             it is a dead end — but one that is ticked has to stay visible
             or there would be no way to untick it */
          var exists = cards.some(function (c) {
            return (c.getAttribute("data-ay-f-" + g) || "").split(" ").indexOf(val) > -1;
          });
          opt.hidden = !exists && !(box && box.checked);
          if (!opt.hidden) live++;
          var nEl = q("[data-ay-fopt-n]", opt);
          if (nEl) nEl.textContent = n;
          opt.dataset.empty = n === 0 ? "true" : "false";
        });
        group.hidden = live === 0;
      });

      /* the bar */
      var countEl = q("[data-ay-filter-count]", bar);
      var n = active();
      if (countEl) { countEl.textContent = n; countEl.hidden = n === 0; }
      var openBtn = q("[data-ay-filter-open]", bar);
      if (openBtn) openBtn.setAttribute("aria-pressed", n > 0 ? "true" : "false");

      var sum = q("[data-ay-filter-summary]", bar);
      var unit = shown === 1 ? T("pair", "pair") : T("pairs", "pairs");
      if (sum) sum.textContent = shown + " " + unit;
      var doneN = q("[data-ay-filter-n]", panelEl);
      if (doneN) doneN.textContent = shown + " " + unit;

      pills();

      var empty = root.querySelector("[data-ay-filter-empty]");
      if (empty) empty.hidden = !(shown === 0 && n > 0);
      if (grid) grid.hidden = shown === 0 && n > 0;
      /* with every page in the DOM the pager is describing a page that no
         longer exists on its own */
      var pag = root.querySelector("[data-ay-pag]");
      if (pag && loadedAll) pag.hidden = true;
    }

    function pills() {
      var wrap = q("[data-ay-filter-pills]", bar);
      if (!wrap) return;
      wrap.innerHTML = "";
      GROUPS.forEach(function (g) {
        (state[g] || []).forEach(function (val) {
          var opt = q('[data-ay-fgroup="' + g + '"] [data-ay-fopt="' + val + '"]', panelEl);
          var label = opt ? (q(".ay-fopt__lbl", opt) || {}).textContent : val;
          var pill = document.createElement("span");
          pill.className = "ay-fpill";
          pill.appendChild(document.createTextNode(label || val));
          var x = document.createElement("button");
          x.type = "button";
          x.setAttribute("aria-label", T("remove_filter", "Remove filter") + " " + (label || val));
          x.innerHTML = '<svg width="10" height="10" viewBox="0 0 18 18" fill="none" aria-hidden="true"><path d="M1 1l16 16M17 1L1 17" stroke="currentColor" stroke-width="2.2"/></svg>';
          on(x, "click", function () { toggle(g, val, false); });
          pill.appendChild(x);
          wrap.appendChild(pill);
        });
      });
    }

    function syncBoxes() {
      all("[data-ay-fbox]", panelEl).forEach(function (b) {
        var g = b.getAttribute("data-ay-fbox");
        b.checked = (state[g] || []).indexOf(b.value) > -1;
      });
    }

    function push() {
      var u = new URL(window.location.href);
      writeParams(u.searchParams);
      window.history.replaceState({ ayColl: true }, "", u.pathname + (u.search ? u.search : "") );
    }

    function toggle(g, val, onState) {
      var list = state[g] || (state[g] = []);
      var i = list.indexOf(val);
      if (onState && i === -1) list.push(val);
      if (!onState && i > -1) list.splice(i, 1);
      syncBoxes();
      ensureAll().then(function () { paint(); push(); });
    }

    function clear() {
      GROUPS.forEach(function (g) { state[g] = []; });
      syncBoxes();
      paint();
      push();
    }

    /* Pull the pages this grid does not have yet, once, the first time a
       filter is used. Filtering only what page one happened to contain
       would quietly lie about the collection. */
    function ensureAll() {
      if (loadedAll || !root) return Promise.resolve();
      var pag = root.querySelector("[data-ay-pag]");
      var pages = pag ? parseInt(pag.getAttribute("data-ay-pages"), 10) : 1;
      var sid = root.getAttribute("data-ay-section-id");
      if (!pages || pages < 2 || !sid || !window.DOMParser) { loadedAll = true; return Promise.resolve(); }

      if (grid) grid.dataset.busy = "true";
      var jobs = [];
      for (var pnum = 2; pnum <= pages; pnum++) {
        var u = new URL(window.location.href);
        u.searchParams.set("page", String(pnum));
        u.searchParams.set("section_id", sid);
        jobs.push(fetch(u.toString()).then(function (r) { return r.text(); }));
      }
      return Promise.all(jobs)
        .then(function (htmls) {
          htmls.forEach(function (html) {
            var doc = new DOMParser().parseFromString(html, "text/html");
            var g2 = doc.querySelector("[data-ay-grid]");
            if (!g2 || !grid) return;
            all("[data-ay-f]", g2).forEach(function (card) {
              card.dataset.ayIn = "true";
              grid.appendChild(document.importNode(card, true));
            });
          });
          loadedAll = true;
          collect();
          if (grid) grid.dataset.busy = "false";
        })
        .catch(function () {
          /* one bad page should not take the filter down with it — carry
             on against what is here and say nothing louder than that */
          loadedAll = true;
          if (grid) grid.dataset.busy = "false";
        });
    }

    /* ---- the panel ---- */
    function open(from) {
      opener = from || document.activeElement;
      panelEl.hidden = false;
      void panelEl.offsetWidth;
      panelEl.dataset.open = "true";
      document.body.style.overflow = "hidden";
      var btn = q("[data-ay-filter-open]", bar);
      if (btn) btn.setAttribute("aria-expanded", "true");
      var f = q(".ay-fpanel__x", panelEl);
      if (f) f.focus({ preventScroll: true });
      /* start the extra pages downloading the moment the panel opens, so
         the first tick does not have to wait for them */
      ensureAll().then(paint);
    }
    function close(refocus) {
      panelEl.dataset.open = "false";
      document.body.style.overflow = "";
      var btn = q("[data-ay-filter-open]", bar);
      if (btn) btn.setAttribute("aria-expanded", "false");
      setTimeout(function () { panelEl.hidden = true; }, CLOSE_MS);
      if (refocus && opener && opener.focus) opener.focus({ preventScroll: true });
    }

    /* ---- stuck state for the bar ---- */
    function armStick() {
      var sentinel = root.querySelector("[data-ay-stick-sentinel]");
      if (!sentinel || !window.IntersectionObserver || !bar) return;
      new IntersectionObserver(function (entries) {
        bar.dataset.stuck = entries[0].isIntersecting ? "false" : "true";
      }, { threshold: 0 }).observe(sentinel);
    }

    function build() {
      root = document.querySelector("[data-ay-coll]");
      if (!root) return false;
      bar = root.querySelector("[data-ay-filterbar]");
      panelEl = root.querySelector("[data-ay-filter-panel]");
      grid = root.querySelector("[data-ay-grid]");
      if (!bar || !panelEl || !grid) return false;

      collect();
      loadedAll = false;

      on(q("[data-ay-filter-open]", bar), "click", function (e) { open(e.currentTarget); });
      all("[data-ay-filter-close]", panelEl).forEach(function (b) {
        on(b, "click", function () { close(true); });
      });
      on(q("[data-ay-filter-done]", panelEl), "click", function () { close(true); });
      all("[data-ay-filter-clear]", root).forEach(function (b) {
        on(b, "click", function () { clear(); });
      });
      on(panelEl, "change", function (e) {
        var box = e.target.closest("[data-ay-fbox]");
        if (!box) return;
        toggle(box.getAttribute("data-ay-fbox"), box.value, box.checked);
      });
      /* build() runs again after every sort or page swap, and these two
         outlive the markup they were bound for — binding them each time
         would stack a fresh Escape handler and a fresh observer on every
         re-render. The panel is looked up live, so one of each is enough. */
      if (!bound) {
        bound = true;
        on(document, "keydown", function (e) {
          if (!panelEl || panelEl.hidden) return;
          if (e.key === "Escape") { e.preventDefault(); close(true); return; }
          trap(panelEl, e);
        });
        armStick();
      }

      syncBoxes();
      paint();
      return true;
    }

    function init() {
      state = readParams(new URL(window.location.href).searchParams);
      if (!build()) return;
      /* arriving on a filtered URL means the rest of the collection is
         needed straight away, or the link would show the wrong pairs */
      if (active() > 0) ensureAll().then(paint);
    }

    window.AYFilters = {
      writeParams: writeParams,
      /* Called after a sort or a page swap has replaced this markup. The
         URL is the state, not the closure — a sort carried the filters
         along in the query string, so re-read them rather than trusting
         what was in memory before the swap. */
      rebuild: function () {
        state = readParams(new URL(window.location.href).searchParams);
        if (build() && active() > 0) ensureAll().then(paint);
      }
    };

    if (document.querySelector("[data-ay-filter-panel]")) init();
  })();
})();
